/**
 * @generated SignedSource<<cf2e8f8aca39fd0339871e16ad8a5be7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SpaceStarReadStarredSpacesFragment$data = {
  readonly nodes: ReadonlyArray<{
    readonly alias: string | null | undefined;
    readonly icon: {
      readonly path: string;
    } | null | undefined;
    readonly id: string | null | undefined;
    readonly key: string | null | undefined;
    readonly name: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "SpaceStarReadStarredSpacesFragment";
};
export type SpaceStarReadStarredSpacesFragment$key = {
  readonly " $data"?: SpaceStarReadStarredSpacesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpaceStarReadStarredSpacesFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "SpaceStarReadStarredSpacesFragment",
  "selections": [
    {
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "alias"
        },
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "concreteType": "Icon",
          "kind": "LinkedField",
          "name": "icon",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "path"
            }
          ]
        }
      ]
    }
  ],
  "type": "PaginatedSpaceList"
};

(node as any).hash = "4a38c9f3868a7bbf44a9931e1d6903ac";

export default node;
